
import axios from "axios";

// =====================================================
// CREATE PAYMENT
// =====================================================

export const PAYMENT_CREATE_REQUEST =
  "PAYMENT_CREATE_REQUEST";

export const PAYMENT_CREATE_SUCCESS =
  "PAYMENT_CREATE_SUCCESS";

export const PAYMENT_CREATE_FAIL =
  "PAYMENT_CREATE_FAIL";

// =====================================================
// VERIFY PAYMENT
// =====================================================

export const PAYMENT_VERIFY_REQUEST =
  "PAYMENT_VERIFY_REQUEST";

export const PAYMENT_VERIFY_SUCCESS =
  "PAYMENT_VERIFY_SUCCESS";

export const PAYMENT_VERIFY_FAIL =
  "PAYMENT_VERIFY_FAIL";

// =====================================================
// RESET PAYMENT
// =====================================================

export const PAYMENT_RESET =
  "PAYMENT_RESET";

// =====================================================
// CSRF HELPER
// =====================================================

const getCsrfToken = async () => {
  const response = await axios.get(
    "/api/kitchen/csrf/",
    {
      withCredentials: true,
    }
  );

  const token = response.data?.csrfToken;

  if (!token) {
    throw new Error(
      "Unable to obtain CSRF token from server."
    );
  }

  return token;
};

// =====================================================
// RESET PAYMENT STATE
// =====================================================

export const resetPayment = () => (dispatch) => {
  dispatch({
    type: PAYMENT_RESET,
  });
};

// =====================================================
// CREATE RAZORPAY ORDER
// =====================================================

export const createRazorpayOrder =
  (restaurantId, orderId, sessionToken) =>
  async (dispatch) => {
    try {
      dispatch({
        type: PAYMENT_CREATE_REQUEST,
      });

      if (!sessionToken) {
        throw new Error(
          "Dining session token is required to create payment."
        );
      }

      // Obtain Django CSRF token
      const csrfToken = await getCsrfToken();

      const response = await axios.post(
        `/api/restaurants/${restaurantId}/payments/create/`,
        {
          order_id: orderId,
          session_token: sessionToken,
        },
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": csrfToken,
          },
        }
      );

      console.log(
        "RAZORPAY CREATE RESPONSE:",
        response.data
      );

      dispatch({
        type: PAYMENT_CREATE_SUCCESS,
        payload: response.data,
      });

      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.error ||
        error.message ||
        "Failed to create payment";

      dispatch({
        type: PAYMENT_CREATE_FAIL,
        payload: message,
      });

      throw error;
    }
  };

// =====================================================
// VERIFY RAZORPAY PAYMENT
// =====================================================

export const verifyRazorpayPayment =
  (restaurantId, paymentData, sessionToken) =>
  async (dispatch) => {
    try {
      dispatch({
        type: PAYMENT_VERIFY_REQUEST,
      });

      if (!sessionToken) {
        throw new Error(
          "Dining session token is required to verify payment."
        );
      }

      // Obtain Django CSRF token
      const csrfToken = await getCsrfToken();

      const response = await axios.post(
        `/api/restaurants/${restaurantId}/payments/verify/`,
        {
          ...paymentData,
          session_token: sessionToken,
        },
        {
          withCredentials: true,
          headers: {
            "Content-Type": "application/json",
            "X-CSRFToken": csrfToken,
          },
        }
      );

      console.log(
        "RAZORPAY VERIFY RESPONSE:",
        response.data
      );

      dispatch({
        type: PAYMENT_VERIFY_SUCCESS,
        payload: response.data,
      });

      return response.data;
    } catch (error) {
      const message =
        error.response?.data?.detail ||
        error.response?.data?.error ||
        error.message ||
        "Payment verification failed";

      dispatch({
        type: PAYMENT_VERIFY_FAIL,
        payload: message,
      });

      throw error;
    }
  };
